export const MuiSelect = {
  select: {
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  selectMenu: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
}
